<ng-container *ngIf="componentIsLoaded('/solar/dashboard')">
    <div [hidden]="!componentIsVisible('/solar/dashboard')">
        <app-db-overview></app-db-overview>
    </div>
</ng-container>

<ng-container *ngIf="componentIsLoaded('/solar/sites')">
    <div [hidden]="!componentIsVisible('/solar/sites')">
        <app-site-list-main></app-site-list-main>
    </div>
</ng-container>

<ng-container *ngIf="componentIsLoaded('/solar/supervision-list')">
    <div [hidden]="!componentIsVisible('/solar/supervision-list')">
        <app-supervis-list-main></app-supervis-list-main>
    </div>
</ng-container>

<!-- <ng-container *ngIf="componentIsLoaded('/solar/supervision-master/')">
    <div [hidden]="!componentIsVisible('/solar/supervision-master/')">
        <app-ex-supervis></app-ex-supervis>
    </div>
</ng-container> -->

<ng-container *ngIf="componentIsLoaded('/verifiers/verifier-detail')">
    <div [hidden]="!componentIsVisible('/verifiers/verifier-detail')">
        <app-verifier-detail></app-verifier-detail>
    </div>
</ng-container>
<ng-container *ngIf="componentIsLoaded('/users/users-list')">
    <div [hidden]="!componentIsVisible('/users/users-list')">
        <app-user-list-main></app-user-list-main>
    </div>
</ng-container>